import Text, { TEXT_VARIANT } from '@pixum/text';
import Button, { ButtonVariants } from '@pixum/button';
import { Icon } from '@pixum/icon';
import type { ContactFormConfirmationProps } from './types';
import clsx from 'clsx';
import { PixumEnvUtils } from 'utils';
import { useRef, useEffect } from 'react';
import styles from './ContactFormConfirmation.module.css';

export function ContactFormConfirmation({ confirmationConstants, onCancel, className }: ContactFormConfirmationProps) {
  const headingRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    headingRef.current?.focus();
  }, []);

  return (
    <div className={clsx(styles.confirmation, className)}>
      <div className={styles.image}>
        <img
          height={192}
          width={192}
          src={`${PixumEnvUtils.get('ASSET_HOST')}/img/icon/email_success.svg`}
          alt={confirmationConstants.successHeadline}
        />
      </div>
      <div className={styles.info}>
        <div ref={headingRef} tabIndex={-1}>
          <Text variant={TEXT_VARIANT.HEADLINE}>{confirmationConstants.successHeadline}</Text>
        </div>
        <Text className={styles.message}>{confirmationConstants.successText}</Text>
        <Button
          className={styles.cancelButton}
          onClick={onCancel}
          label={confirmationConstants.close}
          variant={ButtonVariants.SECONDARY}
          type="button"
        >
          <Icon name="close" />
          <span>{confirmationConstants.close}</span>
        </Button>
      </div>
    </div>
  );
}
